import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'
// 配件详情(前台)
export function getgoodsdetails(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/partsBatch/getPart',
    method: 'get',
    params
  })
}
// 商铺基本信息(前台)
export function gethotsell(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/partsBatch/getSalesVolume',
    method: 'get',
    params
  })
}
// 加入购物车(前台)---活动商品
export function getshopcar1(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/shopping/saveShoppingCart1',
    method: 'post',
    data
  })
}
// 加入购物车(前台)---非活动商品
export function getshopcar(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/shopping/saveShoppingCart',
    method: 'post',
    data
  })
}
// 适用车型(前台)
export function getapplycar(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/partsBatch/getCarModelNew',
    method: 'post',
    data
  })
}
// 商品总价(前台)
export function getbuygoods(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/shopping/discount',
    method: 'post',
    data
  })
}

// 立即购买(前台)---非活动商品
export function getpromptlybuy(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/orders/parts/prebuy',
    // url: 'http://192.168.0.108:5000/wss-order/orders/parts/prebuy',
    method: 'post',
    data
  })
}
// 立即购买(前台)----活动商品
export function getpromptlybuy1(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/orders/parts/prebuy1',
    // url: 'http://192.168.0.108:5000/wss-order/orders/parts/prebuy',
    method: 'post',
    data
  })
}

// 顶部图片
export function getBasicShopMsg(params) {
  return axios.request({
    url: urlObj.crm + 'crm/tenant/shopinfo',
    method: 'get',
    params
  })
}

// 我的关注
export function getattention(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/attention',
    method: 'get',
    params
  })
}

// //获取客服信息
// export const rmCustomerService = data => {
//   return axios.request({
//     url: `${urlObj.gpartsApi}/groupCustomer/getGroupCustomer?storeCode=${data.storeCode}&groupType=${data.groupType}`,
//     method: 'post'
//   })
// }

// //获取chat
// export function getRmChat(data) {
//   return axios.request({
//     url: `${urlObj.tokenApi}/xpmsg/getUserId?loginName=${data.loginName}`,
//     method: 'post',
//     data
//   })
// }

// // 清空计数
// export const deleteCount = () => {
//   return http.post(`${api.tokenApi}/usermessage/deleteCount`, {})
// }

// // 获取客服
// export const getKefus = data => {
//   const userData =
//     JSON.parse(sessionStorage.getItem('loginUserData')) ||
//     JSON.parse(sessionStorage.getItem('userData'))
//   if (!data.id) {
//     data.id = ''
//   }
//   return axios.request({
//     url: `${api.gpartsApi}/groupCustomer/getGroupCustomer?id=${data.id}&name=${userData.loginName}&storeCode=${data.storeCode}&groupType=${data.groupType}`,
//     method: 'post'
//   })
// }
// 获取仓库
export function getWare(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/store/tenant',
    // url: urlObj.zxy + 'wss-order/orders/parts/prebuy',
    method: 'get',
    params
  })
}
// 获取商品库存(加了联盟分仓的需求)
export function getStock(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/info/tenant/stock/detail',
    // url: urlObj.zxy + 'wss-order/orders/parts/prebuy',
    method: 'post',
    data
  })
}
// 配件详情(前台)
export function getgoodsdetailsGroup(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/activity/getGroupDetail',
    method: 'get',
    params
  })
}